import React from 'preact/compat';
import { Field } from 'formik';
import FormLabel from '../label';
import FormError from '../error';

export default function AddressFields() {
    return (
        <div className='form__grid'>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='address1' required={true}>Address line 1</FormLabel>
                <Field name='address.line1' id='address1' className='input  input--text' />
                <FormError name='address.line1' />
            </div>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='address2'>Address line 2 (optional)</FormLabel>
                <Field name='address.line2' id='address2' className='input  input--text' />
                <FormError name='address.line2' />
            </div>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='city' required={true}>Town/city</FormLabel>
                <Field name='address.city' id='city' className='input  input--text' />
                <FormError name='address.city' />
            </div>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='county'>County (optional)</FormLabel>
                <Field name='address.county' id='county' className='input  input--text' />
                <FormError name='address.county' />
            </div>
            <div className='form__grid-item  form__field'>
                <FormLabel htmlFor='postcode' required={true}>Postcode</FormLabel>
                <Field name='address.postcode' id='postcode' className='input  input--text' />
                <FormError name='address.postcode' />
            </div>
        </div>
    );
}
